import { TUserLocation } from './User.types';

export const DESIGNATIONS = [
  'LICENSED_THERAPIST',
  'PRACTICE_OWNER',
  'ADMIN_STAFF',
  'COUNSELOR',
  'SOCIAL_WORKER',
  'PSYCHOLOGIST',
  'FAMILY_THERAPIST',
  'OTHER',
];
export const SCHEDULE_TOOLS = ['PAPER_BASED', 'GOOGLE_CALENDAR', 'OUTLOOK_CALENDAR', 'OTHER'];
export const APPOINTMENT_TYPES = ['IN_PERSON', 'TELEHEALTH', 'GROUP_THERAPY', 'OTHER'];
export const SPECIALTIES = [
  'TRAUMA',
  'ANXIETY',
  'DEPRESSION',
  'ADDICTION',
  'COUPLES',
  'FAMILIES',
  'TEENS',
  'KIDS',
  'ADULTS',
  'LGBTQ+',
  'MILITARY',
  'FIRST_RESPONDERS',
  'PERSONALITY_DISORDERS',
  'OTHER',
];
export const AVAILABILITIES = ['YES', 'NO', 'WAITLIST'];
export const MODALITIES = ['CBT', 'DBT', 'ACT', 'EMDR', 'IFS', 'EFT', 'ART'];

export type TProviderScheduleTool = (typeof SCHEDULE_TOOLS)[number];
export type TProviderDesignation = (typeof DESIGNATIONS)[number];
export type TProviderAppointmentType = (typeof APPOINTMENT_TYPES)[number];
export type TProviderSpecialty = (typeof SPECIALTIES)[number];
export type TProviderAvailability = (typeof AVAILABILITIES)[number];
export type TProviderModality = (typeof MODALITIES)[number];

export type TProvider = {
  first_name: string;
  last_name: string;
  email?: string;
  practice_name: string;
  designation: string[];
  custom_designation?: string;
  bio: string;
  schedule_tools: string[];
  custom_schedule_tool?: string;
  locations?: TUserLocation[];
  ehr_software?: string;
  sync_schedule_interest: boolean;
  appointment_types: string[];
  custom_appointment_type?: string;
  booking_link: string;
  profile_photo?: string;
  specialities: TProviderSpecialty[];
  availability: TProviderAvailability;
  modalities: TProviderModality[];
  population?: string;
};

export type TProviderApi = TProvider & {
  _id: string;
  isActive: boolean;
  created_at: string;
  updated_at: string;
};

export type TProviderFilterOption = 'Designation' | 'Name' | 'Practice Name' | 'Appointment Type';
